import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { getDirectionFromBearing, BearingDirection, unknownBearing } from '@lib/utils';

@Pipe({ name: 'bearing' })
export class BearingPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }

  public transform(startBearing: number, endBearing?: number): string {
    const endBearingDirection: BearingDirection = getDirectionFromBearing(endBearing);
    let startBearingDirection: BearingDirection = getDirectionFromBearing(startBearing);
    startBearingDirection = startBearingDirection === endBearingDirection ? null : startBearingDirection;

    if (startBearing === unknownBearing && endBearing === unknownBearing) return '--';
    if (!endBearing) return this.getBearingVector(startBearing, startBearingDirection);

    return `${this.getBearingVector(startBearing, startBearingDirection)} to ${this.getBearingVector(endBearing, endBearingDirection)}`;
  }

  private getBearingVector(magnitude: number, direction?: BearingDirection): string {
    const magnitudeFormatted: string = this.decimalPipe.transform(magnitude, '1.0-0');

    if (magnitude === unknownBearing) {
      return 'Unknown';
    }

    if (!direction) {
      return `${magnitudeFormatted}°`;
    }

    return `${magnitudeFormatted}° ${direction}`;
  }
}
